import { CounselingTypeEnum } from 'app/Bookings/constants'

export const counselingTypeIconMap: Partial<
  Record<CounselingTypeEnum, string>
> = {
  [CounselingTypeEnum.INDIVIDUAL]: '/icons/IndividualTherapyIcon.svg',
  [CounselingTypeEnum.FAMILY]: '/icons/FamilyTherapyIcon.svg',
  [CounselingTypeEnum.MEDICATION]: '/icons/MedicationIcon.svg',
  [CounselingTypeEnum.COUPLES]: '/icons/CouplesTherapyIcon.svg',
}

export const counselingTypeSortOrder: Record<string, number> = {
  [CounselingTypeEnum.INDIVIDUAL]: 1,
  [CounselingTypeEnum.MEDICATION]: 2,
  [CounselingTypeEnum.COUPLES]: 3,
  [CounselingTypeEnum.FAMILY]: 4,
}

export const counselingTypeDisplayLabelMap: Partial<
  Record<CounselingTypeEnum, string>
> = {
  [CounselingTypeEnum.COUPLES]: 'Couples therapy',
  [CounselingTypeEnum.FAMILY]: 'Family therapy',
  [CounselingTypeEnum.INDIVIDUAL]: 'Individual therapy',
  [CounselingTypeEnum.MEDICATION]: 'Psychiatry/medication',
}

/**
 * @shared Used by provider search filter pills, profile service type text and
 * the V2 booking session summary, service type dropdown and confirmation card.
 * Display only: booking state, API values and analytics keep the raw value.
 */
export const getServiceTypeDisplayLabel = (value: string): string => {
  switch (value) {
    case CounselingTypeEnum.INDIVIDUAL:
    case CounselingTypeEnum.FAMILY:
    case CounselingTypeEnum.COUPLES:
      return counselingTypeDisplayLabelMap[value] ?? value
    default:
      return value
  }
}

export const counselingTypeDescriptionMap: Partial<
  Record<CounselingTypeEnum, string>
> = {
  [CounselingTypeEnum.INDIVIDUAL]:
    "Work through what's on your mind with a therapist who gets it, whether that's anxiety, depression, or something harder to name",
  [CounselingTypeEnum.MEDICATION]:
    'Meet with a psychiatric provider to explore whether medication might help you feel more like yourself',
  [CounselingTypeEnum.COUPLES]:
    "Work through what's gotten hard—communication, conflict, trust—with a therapist who helps you both feel heard",
  [CounselingTypeEnum.FAMILY]:
    'Navigate the dynamics that make family life complicated and find a path forward that works for everyone',
}
